import axios from 'axios'

export function fetchThemes() {
  return axios.get(`/api/v1/themes/`)
}
